const NetworkStatusMessages = {
  OFFLINE: 'No internet connection',
  UNREACHABLE: 'No connection',
  ONLINE: 'Connected',
  CONNECTING: 'Connecting...',
};

export default NetworkStatusMessages;
